// extracted by mini-css-extract-plugin
var _1 = "DashboardStyle-module__dashboard___cIabL";
var _2 = "DashboardStyle-module__unstake___d87eE";
export { _1 as "dashboard", _2 as "unstake" }
